// extracted by mini-css-extract-plugin
export default {"wishlistListSectionOverrides":"owD6Drxy5lREE7IGf39QnQ=="};